<template>
  <div v-if="feedback.visible" class="app-feedback" role="alert">
    <span>{{ feedback.message }}</span>
    <button type="button" aria-label="Dismiss notification" @click="feedback.visible = false">Dismiss</button>
  </div>
</template>

<script>
import { feedback } from '@/services/errors';
export default {
  name: 'AppFeedback',
  setup: () => ({ feedback })
};
</script>

<style scoped>
.app-feedback {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  width: min(560px, calc(100vw - 32px));
  padding: 16px;
  border-radius: 8px;
  background: #323232;
  color: white;
  box-shadow: 0 4px 16px #0003;
}
button { color: #b9f6ca; margin-left: 12px; text-decoration: underline; }
</style>
